import userContext from './userContext';
import _ from 'lodash';

export function itemPassesFilter(item, itemFilter, projectStates) {

    let statesById = _.keyBy(projectStates, 'id');

    // If excludeAllStates is true but item has states then return false
    if (itemFilter.excludeAllStates && item.states.length > 0) {
        return false;
    }

    // Group stateIdsIncluded by flows, and then check that the item has a state in each of these groups.
    let stateIdsIncludedFilterMatch = _(itemFilter.stateIdsIncluded)
        .groupBy(stateId => statesById[stateId].flowId)
        .every(stateIdsInFlow => item.states.some(state => stateIdsInFlow.includes(state.id)));

    if (!stateIdsIncludedFilterMatch) {
        return false;
    }

    // Check that item does not have states from stateIdsExcluded.
    let stateIdsExcludedFilterMatch = item.states.every(state => {
        return !itemFilter.stateIdsExcluded.includes(state.id);
    });

    if (!stateIdsExcludedFilterMatch) {
        return false;
    }

    // If itemFilter has flowIdsAssigned, then check that current user is assigned to the item for all these flowIds.
    if (itemFilter.flowIdsAssigned && itemFilter.flowIdsAssigned.length) {
        let currentUserId = userContext.getCurrentUser().id;
        let userAssignedToAllFlows = itemFilter.flowIdsAssigned.every(flowId => {
            return _.some(item.assignedUsers, assignedUser => {
                return assignedUser.user.id === currentUserId && assignedUser.flow.id === flowId;
            });
        });
        if (!userAssignedToAllFlows) {
            return false;
        }
    }

    // If itemFilter has flowIdsUnassigned, then check that the item is not assigned to anyone in that flowId.
    if (itemFilter.flowIdsUnassigned && itemFilter.flowIdsUnassigned.length) {
        let noUserAssignedToFlows = itemFilter.flowIdsUnassigned.every(flowId => {
            return _.every(item.assignedUsers, assignedUser => {
                return assignedUser.flow.id !== flowId;
            });
        });
        if (!noUserAssignedToFlows) {
            return false;
        }
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/services/itemFilterService.js